import { toValue, type MaybeRefOrGetter } from "vue";

/**
 * Picks between the legacy (V1) and new (V2) class string for a `newLayout`
 * feature-flag ternary, so call sites stop re-deriving the same
 * `newLayout ? v2Class : legacyClass` branch inline.
 */
export function layoutClass(
  newLayout: MaybeRefOrGetter<boolean>,
  legacyClass: string,
  v2Class: string,
): string {
  return toValue(newLayout) ? v2Class : legacyClass;
}
